import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const AUTOCOMPLETE_USERS_POPUP = "COMMON:AUTOCOMPLETE_USERS_POPUP";

export interface AutocompleteUsersPopupAction extends Action {
  type: typeof AUTOCOMPLETE_USERS_POPUP;
  organization: OrganizationKeyName;
  searchBy: string;
}

export const autocompleteUsersPopupAction = (
  organization: OrganizationKeyName,
  searchBy: string
): AutocompleteUsersPopupAction => ({
  type: AUTOCOMPLETE_USERS_POPUP,
  organization,
  searchBy,
});
